export const API_URL = 'https://api.stringershub.com/api';
export const API_V2_URL = 'https://api-v2.stringershub.com';
export const API_V2_ACCESS_TOKEN = '5e1d1708ae935f26cca3877adb441c3c';

export const S3_BUCKET_URL = 'https://transodebucket.s3.amazonaws.com';
export const IMAGE_URL = 'https://api.stringershub.com/';
export const CLOUDFRONT_URL = 'https://d1tvqsz0v32amf.cloudfront.net/';

export const FACEBOOK_APP_ID = '203362279075408';
